<div class="checked"></div>
<div class="icon"><i *ngIf="icon" [innerHtml]="icon"></i></div>
<div class="label">{{ label }}</div>
<app-tooltip class="info" *ngIf="disabled && reason.length > 0" icon="help_outline">{{
  reason
}}</app-tooltip>
<div class="info" *ngIf="!disabled || reason.length === 0"></div>
<div class="expand"><i>chevron_right</i></div>
<div #menuContent *ngIf="displayMenu" class="menu-content" [ngStyle]="menuContentStyle">
  <div #menuFrame class="menu-frame">
    <div class="menu-canvas">
      <ng-content></ng-content>
    </div>
  </div>
</div>
